import React from 'react';
import './DataTable.css';

/**
 * DataTable
 * @param {Array} columns - [{ key, label, render? }]
 * @param {Array} rows    - array of data objects
 */
export default function DataTable({ columns, rows }) {
  return (
    <div className="data-table-wrap">
      <table className="data-table">
        <thead>
          <tr>
            {Array.isArray(columns) && columns.map((col) => (
              <th key={col.key}>{col.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.isArray(rows) && rows.map((row, i) => (
            <tr key={i}>
              {Array.isArray(columns) && columns.map((col) => (
                <td key={col.key}>
                  {col.render ? col.render(row[col.key], row) : row[col.key]}
                </td>
              ))}
            </tr>
          ))}
          {(!Array.isArray(rows) || rows.length === 0) && (
            <tr>
              <td colSpan={columns?.length || 1} style={{ textAlign: 'center', padding: '20px', color: 'var(--text-muted)' }}>
                No records found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
